// -----------------------------------------------------------
// FloraIQ — Modal Configurar Regra
// -----------------------------------------------------------

import { useState } from "react";

interface ConfigureRuleModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ConfigureRuleModal({ isOpen, onClose }: ConfigureRuleModalProps) {
  const [form, setForm] = useState({
    nome: "",
    grupo: "GIS e Geometria",
    descricao: "",
    severidade: "média",
    status: "ativa",
    moduloRelacionado: "CTA / Mapa",
    acaoRecomendada: "",
    permiteExcecao: false,
    exigeJustificativa: true,
  });

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert("Regra cadastrada com sucesso! (Simulação)");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40 fade-in" onClick={onClose}></div>
      <div className="relative bg-white rounded-card w-full max-w-lg mx-4 p-6 slide-up shadow-lg max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-base font-semibold font-heading text-foreground-900">Configurar Regra de Validação</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer">
            <i className="ri-close-line text-foreground-500"></i>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-foreground-700 mb-1">Nome da Regra</label>
            <input
              type="text"
              className="w-full border border-background-200/70 rounded-md px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
              placeholder="Ex: Toda árvore deve possuir geometria"
              value={form.nome}
              onChange={(e) => setForm({ ...form, nome: e.target.value })}
              required
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-foreground-700 mb-1">Grupo</label>
              <select
                className="w-full border border-background-200/70 rounded-md px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
                value={form.grupo}
                onChange={(e) => setForm({ ...form, grupo: e.target.value })}
              >
                <option>Cadastro Arbóreo</option>
                <option>GIS e Geometria</option>
                <option>Território e Unidade Espacial</option>
                <option>Fontes e Evidências</option>
                <option>RRR e Autorizações</option>
                <option>Histórico e Versionamento</option>
                <option>Nuvem de Pontos</option>
                <option>Fotos e Documentos</option>
                <option>Carbono e Indicadores</option>
                <option>Coletor de Campo</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-foreground-700 mb-1">Severidade</label>
              <select
                className="w-full border border-background-200/70 rounded-md px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
                value={form.severidade}
                onChange={(e) => setForm({ ...form, severidade: e.target.value })}
              >
                <option>informativa</option>
                <option>baixa</option>
                <option>média</option>
                <option>alta</option>
                <option>crítica</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-700 mb-1">Descrição</label>
            <textarea
              className="w-full border border-background-200/70 rounded-md px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
              rows={2}
              placeholder="Descreva a regra de validação..."
              value={form.descricao}
              onChange={(e) => setForm({ ...form, descricao: e.target.value })}
            ></textarea>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-foreground-700 mb-1">Status</label>
              <select
                className="w-full border border-background-200/70 rounded-md px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
                value={form.status}
                onChange={(e) => setForm({ ...form, status: e.target.value })}
              >
                <option>ativa</option>
                <option>inativa</option>
                <option>em_teste</option>
                <option>obrigatória</option>
                <option>em_revisao</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-medium text-foreground-700 mb-1">Módulo Relacionado</label>
              <input
                type="text"
                className="w-full border border-background-200/70 rounded-md px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
                value={form.moduloRelacionado}
                onChange={(e) => setForm({ ...form, moduloRelacionado: e.target.value })}
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-foreground-700 mb-1">Ação Recomendada</label>
            <input
              type="text"
              className="w-full border border-background-200/70 rounded-md px-3 py-2 text-sm text-foreground-800 focus:outline-none focus:border-blue-400 transition-colors"
              placeholder="Ex: Completar coordenadas das árvores sem geometria"
              value={form.acaoRecomendada}
              onChange={(e) => setForm({ ...form, acaoRecomendada: e.target.value })}
            />
          </div>

          <div className="flex items-center gap-6 pt-1">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={form.permiteExcecao}
                onChange={(e) => setForm({ ...form, permiteExcecao: e.target.checked })}
                className="rounded border-background-300 text-blue-600 focus:ring-blue-400"
              />
              <span className="text-xs text-foreground-700">Permite exceção</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={form.exigeJustificativa}
                onChange={(e) => setForm({ ...form, exigeJustificativa: e.target.checked })}
                className="rounded border-background-300 text-blue-600 focus:ring-blue-400"
              />
              <span className="text-xs text-foreground-700">Exige justificativa</span>
            </label>
          </div>

          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 btn-outline text-xs py-2 cursor-pointer whitespace-nowrap">
              Cancelar
            </button>
            <button type="submit" className="flex-1 btn-primary text-xs py-2 cursor-pointer whitespace-nowrap">
              Salvar Regra
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}